export const CLASS_NAME_IDENTIFIER = 'owenClass&:';

export function returnClassName(className, styleClassNames) {
    const regExp = new RegExp(CLASS_NAME_IDENTIFIER);

    if (!className) return '';

    return className.match(regExp) ? (styleClassNames[className.replace(regExp, '')] || '') : className;
}